__turbopack_context__.v({
  "avatar": "_2CECBG_avatar",
  "avatarAttended": "_2CECBG_avatarAttended",
  "img": "_2CECBG_img",
  "root": "_2CECBG_root",
});
